import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";

export default function OverallMoneyCard() {
    const [data, setData] = useState({ debit: 0, credit: 0, net: 0 });

    useEffect(() => {
        client.fetch(`*[_type == "moneyTransaction"]{givenOrTaken, amount}`)
            .then(items => {
                let d = 0, c = 0;
                items.forEach(i => i.givenOrTaken === "Debit" ? d += +i.amount : c += +i.amount);
                setData({ debit: d, credit: c, net: c - d });
            });
    }, []);

    return (
        <div className="summary-card-grid">
            <div className="summary-card-item">
                <span className="summary-card-label">Debit</span>
                <span className="summary-card-value text-danger">₹{data.debit.toLocaleString()}</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Credit</span>
                <span className="summary-card-value text-success">₹{data.credit.toLocaleString()}</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Balance</span>
                <span className={`summary-card-value ${data.net >= 0 ? "text-success" : "text-danger"}`}>
                    ₹{data.net.toLocaleString()}
                </span>
            </div>
        </div>
    );
}